import { FtuxConfig } from '../types';

/**
 * Ensures the last step in a FTUX config always has "Done" as the button label.
 * This utility function should be called at the end of each config function before returning.
 */
export const ensureLastStepIsDone = (config: FtuxConfig): FtuxConfig => {
	if (config.steps.length === 0) {
		return config;
	}

	const lastStep = config.steps[config.steps.length - 1];

	// Only update if the step has a button
	if (lastStep?.button) {
		lastStep.button = {
			...lastStep.button,
			label: 'Done'
		};
	}

	return config;
};
